import React from 'react'
import { Trans, t } from '@lingui/macro'
import BorderedBox, {
  BorderedBoxStats
} from '../../../components/common/bordered-box/BorderedBox'
import './CampaignAction.less'
import {
  CampaignActionControls,
  CampaignActionEmailSender
} from './commonComponents'
import {
  CampaignActionSurveyModel,
  CampaignSurveyShareActionModelAsEditor
} from 'front-end/src/graphql/private/PrivateSchemaTypes'

const CampaignSurveyShareAction = ({
  onEditClick,
  onDeleteClick,
  surveyShareAction,
  onCopyClick
}: {
  surveyShareAction: CampaignSurveyShareActionModelAsEditor
  onEditClick: (e: React.MouseEvent<HTMLSpanElement>) => void
  onDeleteClick: (e: React.MouseEvent<HTMLSpanElement>) => void
  onCopyClick: (e: React.MouseEvent<HTMLSpanElement>) => void
}) => {
  const getSurveyNames = (
    actionSurveys: CampaignActionSurveyModel[]
  ): string => {
    if (actionSurveys.length === 1) {
      return actionSurveys[0].survey.title
    }

    return t`${actionSurveys.length} surveys`
  }

  return (
    <BorderedBox className="CampaignAction">
      <div className="CampaignAction__icon">
        <i className="Icon icon icon-bubbles" />
      </div>
      <div className="CampaignAction__desc">
        <span>
          <b>
            <Trans>Share survey</Trans>:
          </b>{' '}
          <i>{getSurveyNames(surveyShareAction.actionSurveys)}</i>
        </span>
        <CampaignActionEmailSender
          senderName={surveyShareAction.emailIdentity?.name ?? null}
        />
      </div>

      <CampaignActionControls
        onEditClick={onEditClick}
        onDeleteClick={onDeleteClick}
        onCopyClick={onCopyClick}
      />

      <BorderedBoxStats
        stats={[
          {
            className: 'sent',
            caption: t`Users`,
            value:
              surveyShareAction.sharedCount === 0
                ? '-'
                : surveyShareAction.sharedCount
          },
          {
            className: 'completed',
            caption: t`Completed`,
            value:
              surveyShareAction.sharedCount > 0
                ? surveyShareAction.completedCount
                : '-'
          },
          {
            className: 'effectiveness',
            caption: t`Effectiveness`,
            value:
              surveyShareAction.sharedCount > 0
                ? `${surveyShareAction.effectiveness} %`
                : '-'
          }
        ]}
      />
    </BorderedBox>
  )
}

export default CampaignSurveyShareAction
